import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { MULTI, Selector } from "../Selectors/Selector";
import { sortTermsDescending } from "../TermManagement/utils";

const CanvasTermSelect = ({
  id = "canvas-term-select",
  selectHandler,
  selectedTerms,
  selectedCanvasTerms,
  label,
  size,
}) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let canvasTermList = [];
    selectedTerms.forEach((term) => {
      canvasTermList.push(...term.canvas_terms);
    });

    canvasTermList = sortTermsDescending(canvasTermList);

    setOptions(
      canvasTermList.map((term) => {
        return { ...term, label: term.name };
      })
    );
  }, [selectedTerms]);

  return (
    <Selector
      type={MULTI}
      id={id}
      label={label ?? t("insightsTerms.canvasTerms")}
      size={size}
      selectHandler={selectHandler}
      options={options}
      selectedOptions={selectedCanvasTerms}
      interaction={options.length > 0}
    />
  );
};

export default CanvasTermSelect;
